<template>
<div class="seekers-form">
    <div class="row">
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Фамилия*"
                name="last-name"
                ref="last-name"
                required
                v-model="params['last-name']"
            />
        </div>
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Имя*"
                name="first-name"
                ref="first-name"
                required
                v-model="params['first-name']"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Отчество*"
                name="middle-name"
                ref="middle-name"
                required
                v-model="params['middle-name']"
            />
        </div>
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Номер телефона*"
                name="phone"
                type="tel"
                required
                ref="phone"
                mask="+7 (###) ###-##-##"
                v-model="params.phone"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-default-6 col-v-tablet-12">
            <z-input
                placeholder="Электронная почта"
                name="email"
                ref="email"
                type="email"
                v-model="params.email"
            />
        </div>
        <div class="col-default-6 col-v-tablet-12">
            <div class="z-input" v-if="this.idv > 0">
                Желаемая должность<br>{{params.position}}
                <input type="hidden" v-model="params.position" >
            </div>

            <z-input v-else
                placeholder="Желаемая должность*"
                name="position"
                ref="position"
                required
                v-model="params.position"
            />
        </div>
    </div>

    <z-tabs class="u-bottom-margin--l u-top-margin--s-important" only-visual @toggle-item="onTabChange">
        <template v-slot:label>
            <z-tabs-label
                v-for="item in tabs"
                :id="item.id"
                :key="item.id"
                :initial-state="item.selected"
            >
                <span v-html="item.text"></span>
            </z-tabs-label>
        </template>
    </z-tabs>

    <div v-if="type === 'form'">
        <z-caption tag="p" class="u-bottom-margin--xs" size="m">Личная информация</z-caption>
        <div class="row">
            <div class="col-default-6 col-v-tablet-12">
                <z-input
                    placeholder="Город проживания*"
                    name="city"
                    ref="city"
                    required
                    v-model="params['personal-data'][0].city"
                />
            </div>
            <div class="col-default-6 col-v-tablet-12">
                <z-date-picker
                    value-type="format"
                    placeholder="Дата рождения*"
                    required
                    name="birthday"
                    ref="birthday"
                    v-model="params['personal-data'][0].birthday"
                />
            </div>
        </div>

        <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="m">Опыт работы</z-caption>
        <seeker-block
            @change="onBlockDataChange"
            ref="experience"
            component="experience"
            btn-text="Добавить место работы"
        />

        <z-caption tag="p" class="u-top-margin--m u-bottom-margin--xs" size="m">Образование</z-caption>
        <seeker-block
            @change="onBlockDataChange"
            ref="education"
            component="education"
            btn-text="Добавить место учёбы"
        />
    </div>

    <div v-if="type === 'file'">
        <z-input-file name="resume-file" ref="resume-file" @change="onFileChange" required>
            <template #trigger>
                <z-button tag="div" kind="secondary" type="button">
                    <span>Загрузите резюме или сопроводительное письмо</span>
                    <template v-slot:right>
                        <z-icon
                            name="paper-clip"
                            width="24"
                            height="24"
                        />
                    </template>
                </z-button>
            </template>
        </z-input-file>
    </div>

    <p class="black-60-text u-top-margin--m text-size-2xs">
        Поля, помеченные <span class="black-90-text">*</span> обязательны для&nbsp;заполнения
    </p>
    <p class="u-top-margin--2xs">
        Ваша личная информация обрабатывается отделами по&nbsp;подбору персонала, которые рассмотрят и&nbsp;обработают ваше заявление на&nbsp;объявленную вакансию и&nbsp;свяжутся с&nbsp;вами. Если Вам необходима дополнительная информация о&nbsp;том, как Ваша личная информация обрабатывается и&nbsp;используется рекрутинговыми командами Распадская угольная компания, ознакомьтесь с&nbsp;расширенным Положением о&nbsp;конфиденциальности данных, с&nbsp;которым можно ознакомиться по&nbsp;следующей <z-link blank href="https://files.raspadskaya.com/files/ru/politica_privacy.pdf">ссылке.</z-link>
    </p>

    <z-checkbox
        class="u-top-margin--m"
        name="agreement"
        ref="agreement"
        @change="onBlockDataChange"
        required
        :checked="params.agreement"
    >
        Ставя галочку на&nbsp;против этой графы, Вы&nbsp;соглашаетесь на&nbsp;обработку и&nbsp;использование Вашей личной информации, как описано выше. Вы&nbsp;имеете право в&nbsp;любое время отозвать свое согласие или возразить против дальнейшей обработки Вашей личной информации.
    </z-checkbox>

    <div class="seekers-form__buttons">
        <z-button @click="submit">Отправить резюме</z-button>
        <z-button @click="reset" kind="secondary">Сбросить всё</z-button>
    </div>

    <z-modal
        id="success-modal"
    >
        <div class="seekers-form-success">
            <z-icon
                name="worker"
                width="96"
                height="96"
                class="u-bottom-margin--m"
            />
            <p>
                Спасибо за&nbsp;проявленный интерес к&nbsp;нашей компании! При положительном рассмотрении резюме мы&nbsp;свяжемся с&nbsp;Вами в&nbsp;течении 3-х рабочих дней.
            </p>
        </div>
    </z-modal>
</div>
</template>

<script>
import SeekerBlock from './components/SeekerBlock.vue'
const axios = require('axios').default

export default {
    name: 'seekers-form',
    props: {
        position: String,
        idv: String
    },
    components: {
        SeekerBlock
    },
    data () {
        return {
            isLoading: false,
            params: {
                'first-name': '',
                'last-name': '',
                'middle-name': '',
                phone: '',
                email: '',
                position: '',
                agreement: false,
                'resume-file': null,
                'personal-data': [
                    {
                        'city': '',
                        'birthday': ''
                    }
                ],
                education: [],
                experience: []
            },
            type: 'form',
            tabs: [
                {
                    id: 'form',
                    selected: true,
                    text: 'Заполнить анкету'
                },
                {
                    id: 'file',
                    selected: false,
                    text: 'Прикрепить резюме'
                }
            ]
        }
    },
    methods: {
        onBlockDataChange (data) {
            this.params[data.name] = data.value
        },
        onTabChange (tab) {
            const type = tab.replace('tabs-', '')
            this.tabs.forEach(obj => {
                if (obj.id === type) {
                    obj.selected = true
                } else {
                    obj.selected = false
                }
            })

            this.clearSecondPart()
            this.type = type
        },
        clearSecondPart () {
            const components = [
                'experience',
                'education'
            ]

            components.forEach(item => {
                if (this.$refs[item]) {
                    try {
                        this.$refs[item].reset()
                    } catch (e) {
                        console.error(`error on reset ${item}`)
                    }
                }
            })

            this.params = {
                ...this.params,
                'personal-data': [
                    {
                        'city': '',
                        'birthday': ''
                    }
                ],
                education: [],
                experience: []
            }
        },
        onFileChange (data) {
            if (data.length) {
                this.params['resume-file'] = data[0]
            } else {
                this.params['resume-file'] = null
            }
        },
        submit () {
            const isValid = this.isValid()

            if (isValid && !this.isLoading) {
                this.isLoading = true
                this.send()
            }
        },
        send () {
            let formData = this.buildFormData(this.params)

            // axios потому, что какая-то херня с отправкой файлов с нашей утилитой
            axios.post(`/${this.$root.lang}/api/vacancies/save-form/`, formData)
                .then(res => {
                    if (res.status === 'error') {
                        console.log(res.message)
                        // showNotyfications(res.message, { type: 'error' })
                    } else {
                        // console.log(res)
                        this.reset()
                        this.openSuccessModal()
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        buildFormData (data) {
            let formData = new FormData()
            formData.append('idv', this.idv)
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if (Array.isArray(data[key])) {
                        for (let value in data[key]) {
                            if (key === 'education' || key === 'experience' || key === 'personal-data') {
                                formData.append(key + '[]', JSON.stringify(data[key][value]))
                            } else {
                                formData.append(key + '[]', data[key][value])
                            }
                        }
                    } else {
                        formData.append(key, data[key])
                    }
                }
            }

            return formData
        },
        openSuccessModal () {
            if (typeof window.ym === 'function') {
                ym(98241852, 'reachGoal', 'form-send')
            }
            this.$root.$bus.$emit('open-modal', {id: 'success-modal', index: 1})
        },
        reset () {
            const components = [
                'experience',
                'education'
            ]

            components.forEach(item => {
                if (this.$refs[item]) {
                    try {
                        this.$refs[item].reset()
                    } catch (e) {
                        console.error(`error on reset ${item}`)
                    }
                }
            })

            this.params = {
                'first-name': '',
                'last-name': '',
                'middle-name': '',
                phone: '',
                email: '',
                position: this.position ? this.position : '',
                agreement: false,
                'resume-file': null,
                'personal-data': [
                    {
                        'city': '',
                        'birthday': ''
                    }
                ],
                education: [],
                experience: []
            }

            if (this.$refs.agreement) this.$refs.agreement.check = false
            if (this.$refs['resume-file']) this.$refs['resume-file'].clear()
        },
        isValid () {
            let isValid = true

            let fields = [
                'last-name',
                'first-name',
                'middle-name',
                'phone',
                'position',
                'email',
                'city',
                'birthday',
                'agreement',
                'resume-file'
            ]

            const components = [
                'experience',
                'education'
            ]

            if (this.type === 'form') {
                fields = fields.concat(components)
            }

            fields.forEach(item => {
                if (this.$refs[item]) {
                    try {
                        this.$refs[item].validate()
                        if (this.$refs[item].error) {
                            isValid = false
                        }
                    } catch (e) {
                        console.error(`error on validate ${item}`)
                    }
                }
            })

            return isValid
        }
    },
    created () {
        if (this.position) this.params.position = this.position
    }
}
</script>

<style lang="scss">
.seekers-form {
    padding-right: $token-spacers-s; // для компенсации кнопок удалить блок

    @include breakpoint (mobile) {
        padding-right: 0;
    }

    .row {
        margin-top: -$token-spacers-xs;

        & + * {
            margin-top: $token-spacers-xs;
        }

        & > [class*="col-"] {
            margin-top: $token-spacers-xs;
        }
    }

    .z-button--kind-text {
        .z-button__icon {
            path {
                fill: $token-colors-white;
            }
        }
    }

    &__buttons {
        @include margin-level(top, M);
        display: flex;

        @include breakpoint (mobile) {
            display: block;
        }

        .z-button {
            @include margin-level(right, S);

            &:last-child {
                margin-right: 0;
            }

            @include breakpoint (mobile) {
                margin-right: 0;
                @include margin-level(top, S);
            }
        }
    }

    &__add-button {
        display: flex;
        justify-content: flex-end;
        margin-top: $token-spacers-xs;
    }

    .z-modal__container {
        background: none;
        padding: 0;
    }

    .z-modal__close {
        @include breakpoint (v-tablet) {
            left: auto;
            right: 0;
            bottom: 100%;
            top: auto;
            margin-bottom: 6px;
        }
    }

    .modal-html {
        max-width: 720px;
    }
}

.seekers-form-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: $token-colors-black-80;
    @include typo-level(M);
    font-weight: 500;
    line-height: 1.4;
    text-align: center;
    padding: $token-spacers-xl;
    width: 100%;
    background: $token-colors-white;

    @include breakpoint (v-tablet) {
        padding: $token-spacers-xl $token-spacers-l;
    }

    @include breakpoint (v-tablet) {
        padding: $token-spacers-l $token-spacers-xs;
    }
}
</style>
